import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransactionRowDesktopConstants } from '@payments/payments-shared/transaction-row/desktop/transaction-row-desktop.component';
import { CancelPendingPaymentsService } from '@payments/services/cancel-pending-payments/cancel-pending-payments.service';
import { PaymentTransactionsViewModel, Status } from '@usf/payment-types';
import {
  RecentInvoicesCreditsText,
  TransactionRowText,
} from '../../models/payment-transaction';

@Component({
  template: '',
})
export class RecentInvoicesCreditsComponent {
  @Input() recentInvoices: PaymentTransactionsViewModel[] = [];
  @Input() recentCredits: PaymentTransactionsViewModel[] = [];
  @Input() isMobile: boolean;
  @Input() translatorText: RecentInvoicesCreditsText;
  @Input() transactionRowText: TransactionRowText;
  @Input() paymentsEnabled = false;
  @Input() showOrderNumber = false;

  @Output() allInvoicesClickEmitter = new EventEmitter<any>();
  @Output() invoicesAndCreditsOptionsEmitter = new EventEmitter<{
    event?: Event;
    transaction: PaymentTransactionsViewModel;
    showPayButton: boolean;
  }>();
  @Output()
  payInvoiceClickEmitter = new EventEmitter<PaymentTransactionsViewModel>();
  @Output()
  viewInvoiceClickEmitter = new EventEmitter<PaymentTransactionsViewModel>();

  Status = Status;
  showFullPO = false;
  columnSizes: Map<
    TransactionRowDesktopConstants.ColumnNames,
    string | number
  > = new Map();
  readonly ColumnNames = TransactionRowDesktopConstants.ColumnNames;

  constructor(public cancelPaymentsService: CancelPendingPaymentsService) {}

  async openMoreOptions(e: {
    event?: Event;
    transaction: PaymentTransactionsViewModel;
    showPayButton: boolean;
  }) {
    this.invoicesAndCreditsOptionsEmitter.emit(e);
  }

  payInvoice(transaction: PaymentTransactionsViewModel) {
    this.payInvoiceClickEmitter.emit(transaction);
  }

  viewInvoice(transaction: PaymentTransactionsViewModel) {
    this.viewInvoiceClickEmitter.emit(transaction);
  }
}
